// extracted by mini-css-extract-plugin
export default {"p_content":"d88ba2fcb1"};